import React from 'react';
import { ASSETS } from '../assets/assetMapping';

const imgUnion = ASSETS.FOOTER_LOGO; // Using BIGVU icon as fallback
const imgVector26 = ASSETS.FOOTER_DIVIDER; // Using BIGVU logo as fallback

interface FooterProps {
  property1?: "Mobile" | "Desctop";
}

function Footer({ property1 = "Desctop" }: FooterProps) {
  return (
    <div className="flex gap-4 items-center justify-start relative w-full h-[45px]" data-name="Property 1=Desctop" data-node-id="2476:78720">
      <div className="h-[31.031px] relative shrink-0 w-[72px]" data-name="Union" data-node-id="2476:78698">
        <img alt="" className="block max-w-none w-full h-full" src={imgUnion} />
      </div>
      <div className="h-10 relative shrink-0 w-0" data-node-id="2476:78707">
        <div className="absolute bottom-0 left-[-0.5px] right-[-0.5px] top-0" style={{ "--stroke-0": "rgba(37, 54, 88, 1)" } as React.CSSProperties}>
          <img alt="" className="block max-w-none w-full h-full" src={imgVector26} />
        </div>
      </div>
      <div className="flex flex-col gap-[5px] items-start justify-start relative shrink-0" data-name="Footer Text" data-node-id="2476:78708">
        <div className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] relative shrink-0" data-node-id="2476:78709">
          <p className="leading-[1.4] whitespace-pre">© 2025 BIGVU INC — New York. All Rights Reserved</p>
        </div>
        <div className="flex gap-[7px] items-center justify-start relative shrink-0" data-name="Footer Links" data-node-id="2476:78710">
          <a href="https://bigvu.tv/terms?utm_source=prompt2avatar" className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] relative shrink-0 cursor-pointer hover:underline" data-node-id="2476:78711">
            <p className="leading-[1.4] whitespace-pre">Terms</p>
          </a>
          <div className="bg-blue-black-90 h-[15px] shrink-0 w-px" data-name="Divider" data-node-id="2476:78712" />
          <a href="https://bigvu.tv/privacy-policy?utm_source=prompt2avatar" className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] relative shrink-0 cursor-pointer hover:underline" data-node-id="2476:78713">
            <p className="leading-[1.4] whitespace-pre">Privacy</p>
          </a>
          <div className="bg-blue-black-90 h-[15px] shrink-0 w-px" data-name="Divider" data-node-id="2476:78714" />
          <a href="https://bigvu.tv/ccpa?utm_source=prompt2avatar" className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] relative shrink-0 cursor-pointer hover:underline" data-node-id="2476:78715">
            <p className="leading-[1.4] whitespace-pre">CCPA</p>
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Footer1() {
  return (
    <div className="w-full max-w-[380px] lg:max-w-[451px] mx-auto">
      {/* Mobile Footer */}
      <div className="lg:hidden flex flex-col items-center justify-center gap-3 py-4">
        <div className="h-6 w-14">
          <img alt="" className="block max-w-none w-full h-full" src={imgUnion} />
        </div>
        <div className="flex flex-col gap-[5px] items-center justify-center text-center">
          <div className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4]">
            <p className="leading-[1.4] whitespace-nowrap">© 2025 BIGVU INC — New York. All Rights Reserved</p>
          </div>
          <div className="flex gap-[7px] items-center justify-center">
            <a href="https://bigvu.tv/terms?utm_source=prompt2avatar" className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] cursor-pointer hover:underline">
              <p className="leading-[1.4] whitespace-pre">Terms</p>
            </a>
            <div className="bg-blue-black-90 h-[15px] w-px" />
            <a href="https://bigvu.tv/privacy-policy?utm_source=prompt2avatar" className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] cursor-pointer hover:underline">
              <p className="leading-[1.4] whitespace-pre">Privacy</p>
            </a>
            <div className="bg-blue-black-90 h-[15px] w-px" />
            <a href="https://bigvu.tv/ccpa?utm_source=prompt2avatar" className="font-inter font-normal text-[14px] text-blue-black-90 leading-[1.4] cursor-pointer hover:underline">
              <p className="leading-[1.4] whitespace-pre">CCPA</p>
            </a>
          </div>
        </div>
      </div>

      {/* Desktop Footer */}
      <div className="hidden lg:flex gap-4 items-center justify-start relative w-full h-[45px]">
        <Footer />
      </div>
    </div>
  );
}
